export default __webpack_public_path__ + "static/media/down.1e3c991e.svg";